import React from 'react'
import { Button } from 'reactstrap'

const AddButton = ({onClick =() => {} , title , type='submit'}) => {
  return (
    
    <Button type={type} onClick={onClick} className="mt-4 " style={{backgroundColor : '#DB2777' , borderColor : "#DB2777" , color : "white"}}>
        {title}
    </Button>
    // <button onClick={onClick} >{title}</button>
  )
}

export default AddButton